
import React, { Component } from "react";

export default class ButtonLoader extends Component {
  
    state = {
      loading: this.props.loading,
    };

    render() {
      
      const clasesBoton = `btn btn-primary btn-primary__submit ${this.props.clase || ""}`;

      return (
          <button 
            className={clasesBoton}
            onClick={(event) => this.props.callFunctionButton(event)}  
            disabled={this.props.loading || this.props.bloqueado}
          >
            {this.props.loading && (
              <i className="fas fa-sync fa-spin" style={{ marginRight: "5px" }}/>
            )}
            {this.props.loading && <span> {this.props.textProcessing} </span>}
            {!this.props.loading && <span>{this.props.text}</span>}
          </button>
      );
    }
  }
  